import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [footerSocial, setFooterSocial] = useState([]);
  const [footerCopyright, setFooterCopyright] = useState([]);
  const [logo, setLogo] = useState([]);
  const [footerAddress, setFooterAddress] = useState([]);
  const [isScrollVisible, setIsScrollVisible] = useState(false); // State for "Scroll to Top" button visibility

  // Fetch logo data
  useEffect(() => {
    fetch(`https://seoaudit02-2nd-a6f62d82ab8a.herokuapp.com/logo`)
      .then((res) => res.json())
      .then((info) => setLogo(info));
  }, []);

  // Fetch footer address
  useEffect(() => {
    fetch(`https://seoaudit02-2nd-a6f62d82ab8a.herokuapp.com/footer-address`)
      .then((res) => res.json())
      .then((info) => setFooterAddress(info));
  }, []);

  // Fetch social links
  useEffect(() => {
    fetch(`https://seoaudit02-2nd-a6f62d82ab8a.herokuapp.com/footer-social`)
      .then((res) => res.json())
      .then((info) => setFooterSocial(info));
  }, []);

  // Fetch copyright
  useEffect(() => {
    fetch(`https://seoaudit02-2nd-a6f62d82ab8a.herokuapp.com/copyrights`)
      .then((res) => res.json())
      .then((info) => setFooterCopyright(info));
  }, []);

  // Handle form submission for subscribers
  const handleSubscriber = (event) => {
    event.preventDefault();
    const subemail = event.target.subemail.value;

    const addItem = { subemail };

    fetch(`https://seoaudit02-2nd-a6f62d82ab8a.herokuapp.com/add-subscriber`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(addItem),
    })
      .then((res) => res.json())
      .then(() => {
        alert("Subscription request sent successfully!");
      });
  };

  // Show "Scroll to Top" button when scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsScrollVisible(true);
      } else {
        setIsScrollVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top functionality
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div>
        {footerSocial.map((s) => (
          <footer className="main-footer" key={s.id}>
            <div className="auto-container">
              <div className="widget-section">
                <div className="row clearfix">
                  {/* Logo Widget */}
                  <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                    <div className="footer-widget logo-widget">
                      {logo.map((l) => (
                        <figure className="footer-logo" key={l.id}>
                          <a href="/">
                            <img src={l.logo} alt="Logo" />
                          </a>
                        </figure>
                      ))}
                      <p>{s.aboutText}</p>
                      <ul className="social-links clearfix">
                        <li>
                          <a
                            href={s.fblink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fa-brands fa-facebook" />
                          </a>
                        </li>
                        <li>
                          <a
                            href={s.inslink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fa-brands fa-instagram" />
                          </a>
                        </li>
                        <li>
                          <a
                            href={s.youlink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fa-brands fa-youtube" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Quick Links */}
                  <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                    <div className="footer-widget links-widget ml_60">
                      <div className="widget-title">
                        <h3>Quick Links</h3>
                      </div>
                      <div className="widget-content">
                        <ul className="links-list clearfix">
                          <li>
                            <a href="/">Home</a>
                          </li>
                          <li>
                            <a href="#about-sec">About</a>
                          </li>
                          <li>
                            <a href="#services-sec">Services</a>
                          </li>
                          <li>
                            <a href="#pricing-sec">Pricing</a>
                          </li>
                          <li>
                            <a href="#contact-sec">Contact</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Subscribe Newsletter */}
                  <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                    <div className="footer-widget subscribe-widget">
                      <div className="widget-title">
                        <h3>Subscribe Newsletter</h3>
                      </div>
                      <div className="widget-content">
                        <p>Thank you for subscribing to our newsletter!</p>
                        <div className="form-inner">
                          <form onSubmit={handleSubscriber} method="post">
                            <div className="form-group">
                              <input
                                type="email"
                                name="subemail"
                                placeholder="Email Address"
                                required
                              />
                              <button type="submit" className="theme-btn btn-one">
                                Subscribe
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-bottom centred">
              <div className="auto-container">
                {footerCopyright.map((c) => (
                  <div className="copyright" key={c.id}>
                    <p>{c.copyrightText}</p>
                  </div>
                ))}
              </div>
            </div>
          </footer>
        ))}

        {/* Scroll to Top Button */}
        {isScrollVisible && (
       <div className="scroll-to-top">
       <div>
         <div className="scroll-top-inner">
           <div className="scroll-bar">
             <div className="bar-inner"></div>
           </div>
           <button 
             className="btn btn-danger fw-bold" 
             onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
           >
             Go To Top
           </button>
         </div>
       </div>
     </div>
     
        )}
        
      </div>
    </>
  );
};

export default Footer;
